import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { brokerCasesApi } from 'api/brokerCases/brokerCasesApi';
import { DocumentReviewStatus, DocumentReviewType, EvidenceSection } from 'api/brokerCases/types';
import { DOCUMENT_REVIEW_TYPE_TO_RELEVANT_TASKS } from 'pages/EvidencePage/evidenceConfig';
import { DOCUMENT_REVIEWS_QUERY_KEY } from '../useDocumentReviews/useDocumentReviews';

export function usePrefetchDocumentReviews(caseId: string | undefined, sections: EvidenceSection[]) {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!caseId || sections.length === 0) return;

    const uniqueIndividualIds = new Set<string>();

    for (const section of sections) {
      for (const task of section.tasks) {
        if (
          task.payload.individualId &&
          DOCUMENT_REVIEW_TYPE_TO_RELEVANT_TASKS[DocumentReviewType.CUSTOMER_FINANCES].includes(task.name)
        ) {
          uniqueIndividualIds.add(task.payload.individualId);
        }
      }
    }

    for (const individualId of uniqueIndividualIds) {
      queryClient.prefetchQuery({
        queryKey: [DOCUMENT_REVIEWS_QUERY_KEY, caseId, individualId, DocumentReviewStatus.COMPLETED],
        queryFn: () =>
          brokerCasesApi.getDocumentReviews(
            caseId,
            individualId,
            DocumentReviewStatus.COMPLETED,
            DocumentReviewType.CUSTOMER_FINANCES,
          ),
      });
      queryClient.prefetchQuery({
        queryKey: [DOCUMENT_REVIEWS_QUERY_KEY, caseId, individualId, DocumentReviewStatus.ONGOING],
        queryFn: () =>
          brokerCasesApi.getDocumentReviews(
            caseId,
            individualId,
            DocumentReviewStatus.ONGOING,
            DocumentReviewType.CUSTOMER_FINANCES,
          ),
      });
    }
  }, [caseId, sections, queryClient]);
}
